import { CopyTextButton } from 'components/CopyTextButton';
import * as React from 'react';
import { Container } from 'types/Watchlist';
import { formatDestinationLocationPort, formatLastFreeDay } from 'utils/container-transforms';

interface Props {
  container: Container;
}

export const ContainerDetails: React.FC<Props> = (props) => {
  const { container } = props;
  return (
    <div className="w-[400px] space-y-2">
      <div className="grid grid-cols-2">
        <h4>Ocean Bill of Lading:</h4>
        <div className="flex items-center space-x-2">
          <h4>{container.shipment?.fullBillOfLadingNumber || '-'}</h4>
          {container.shipment?.fullBillOfLadingNumber ? (
            <div>
              <div style={{ position: 'absolute', transform: 'translateY(-50%)' }}>
                <CopyTextButton
                  label="Copy ocean bill of lading"
                  value={container.shipment?.fullBillOfLadingNumber || '-'}
                  variant="icon"
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="grid grid-cols-2">
        <h4>Reference ID:</h4>
        <h4>{container.customer?.code || '-'}</h4>
      </div>
      <div className="grid grid-cols-2">
        <h4>Port of Destination:</h4>
        <h4>{formatDestinationLocationPort(container)?.value || '-'}</h4>
      </div>
      <div className="grid grid-cols-2">
        <h4>(NEW) Last Free Day</h4>
        <h4>{formatLastFreeDay(container)?.value || '-'}</h4>
      </div>
    </div>
  );
};
ContainerDetails.displayName = 'Shipments.DetailDrawer.Header.ContainerDetails';
